import React, { lazy, memo } from 'react';
import { Instagram, Facebook, Twitter, Linkedin, MapPin, Phone, Mail, Clock } from 'lucide-react';
import { Link } from 'react-router-dom';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/dC9Feg3hdeGqa4UKnUKs8W/WhatsApp_Image_2026-03-12_at_12.52.57.jpg';
export function Footer() {
  return <footer className="bg-h2o-950 border-t border-slate-800 pt-16 pb-8 px-6 md:px-12 mt-auto" data-id="element-77">
      <div className="max-w-7xl mx-auto" data-id="element-78">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-79">
          {/* Col 1: Brand */}
          <div data-id="element-80">
            <Link to="/" className="inline-block mb-6 focus-visible-ring rounded-lg" data-id="element-81">
              <img src={LOGO_URL} alt="H2O Event Centre Logo" className="h-[122px] w-auto rounded-md object-contain" data-id="element-82" />
            </Link>
            <p className="text-slate-400 mb-6 leading-relaxed" data-id="element-83">
              Where moments turn into memories. Maryland's premier destination
              for extraordinary events and celebrations.
            </p>
            <div className="flex items-center gap-4" data-id="element-84">
              <a href="#" className="w-10 h-10 rounded-full bg-h2o-900 flex items-center justify-center text-slate-400 hover:text-h2o-cyan hover:bg-h2o-800 transition-colors" aria-label="Instagram" data-id="element-85">
                <Instagram className="w-5 h-5" data-id="element-86" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-h2o-900 flex items-center justify-center text-slate-400 hover:text-h2o-cyan hover:bg-h2o-800 transition-colors" aria-label="Facebook" data-id="element-87">
                <Facebook className="w-5 h-5" data-id="element-88" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-h2o-900 flex items-center justify-center text-slate-400 hover:text-h2o-cyan hover:bg-h2o-800 transition-colors" aria-label="Twitter" data-id="element-89">
                <Twitter className="w-5 h-5" data-id="element-90" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-h2o-900 flex items-center justify-center text-slate-400 hover:text-h2o-cyan hover:bg-h2o-800 transition-colors" aria-label="LinkedIn" data-id="element-91">
                <Linkedin className="w-5 h-5" data-id="element-92" />
              </a>
            </div>
          </div>

          {/* Col 2: Quick Links */}
          <div data-id="element-93">
            <h4 className="text-white font-semibold mb-6 uppercase tracking-wider text-sm" data-id="element-94">
              Quick Links
            </h4>
            <ul className="space-y-3" data-id="element-95">
              <li data-id="element-96">
                <Link to="/" className="text-slate-400 hover:text-h2o-cyan transition-colors inline-block focus-visible-ring rounded-sm" data-id="element-97">
                  Home
                </Link>
              </li>
              <li data-id="element-98">
                <Link to="/facilities" className="text-slate-400 hover:text-h2o-cyan transition-colors inline-block focus-visible-ring rounded-sm" data-id="element-99">
                  Facilities
                </Link>
              </li>
              <li data-id="element-100">
                <Link to="/services" className="text-slate-400 hover:text-h2o-cyan transition-colors inline-block focus-visible-ring rounded-sm" data-id="element-101">
                  Services
                </Link>
              </li>
              <li data-id="element-102">
                <Link to="/gallery" className="text-slate-400 hover:text-h2o-cyan transition-colors inline-block focus-visible-ring rounded-sm" data-id="element-103">
                  Gallery
                </Link>
              </li>
              <li data-id="element-104">
                <Link to="/contact" className="text-slate-400 hover:text-h2o-cyan transition-colors inline-block focus-visible-ring rounded-sm" data-id="element-105">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 3: Event Types */}
          <div data-id="element-106">
            <h4 className="text-white font-semibold mb-6 uppercase tracking-wider text-sm" data-id="element-107">
              Event Types
            </h4>
            <ul className="space-y-3" data-id="element-108">
              {['Weddings', 'Birthdays', 'Corporate', 'Private Parties', 'Galas'].map(type => <li key={type} data-id="element-109">
                  <Link to="/services" className="text-slate-400 hover:text-h2o-cyan transition-colors inline-block focus-visible-ring rounded-sm" data-id="element-110">
                    {type}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Col 4: Contact Info */}
          <div data-id="element-111">
            <h4 className="text-white font-semibold mb-6 uppercase tracking-wider text-sm" data-id="element-112">
              Contact Us
            </h4>
            <ul className="space-y-4" data-id="element-113">
              <li className="flex items-start text-slate-400" data-id="element-114">
                <MapPin className="w-5 h-5 text-h2o-cyan mr-3 shrink-0 mt-0.5" data-id="element-115" />
                <span data-id="element-116">
                  5005 Jackson Street
                  <br data-id="element-117" />
                  Hyattsville, MD 20706
                </span>
              </li>
              <li className="flex items-center text-slate-400" data-id="element-118">
                <Phone className="w-5 h-5 text-h2o-cyan mr-3 shrink-0" data-id="element-119" />
                <span data-id="element-120">(301) 555-H2O0</span>
              </li>
              <li className="flex items-center text-slate-400" data-id="element-121">
                <Mail className="w-5 h-5 text-h2o-cyan mr-3 shrink-0" data-id="element-122" />
                <a href="mailto:events@h2oeventcentre.com" className="hover:text-h2o-cyan transition-colors focus-visible-ring rounded-sm" data-id="element-123">
                  events@h2oeventcentre.com
                </a>
              </li>
              <li className="flex items-start text-slate-400" data-id="element-124">
                <Clock className="w-5 h-5 text-h2o-cyan mr-3 shrink-0 mt-0.5" data-id="element-125" />
                <span data-id="element-126">
                  Mon-Sat: 10AM - 8PM
                  <br data-id="element-127" />
                  Sun: By Appointment
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Map Embed */}
        <div className="w-full h-64 md:h-80 rounded-lg overflow-hidden border border-slate-800 mb-8 relative bg-h2o-900" data-id="element-128">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d49862.45!2d-77.02!3d38.78!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b7b0!2sNational+Harbor!5e0!3m2!1sen!2sus!4v1" width="100%" height="100%" style={{
          border: 0,
          filter: 'grayscale(1) invert(0.9) hue-rotate(180deg) contrast(1.2)'
        }} allowFullScreen={false} loading="lazy" title="H2O Event Centre Location" className="absolute inset-0" data-id="element-129"></iframe>
        </div>

        {/* Copyright */}
        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row items-center justify-between text-sm text-slate-500" data-id="element-130">
          <p data-id="element-131">
            &copy; {new Date().getFullYear()} H2O Event Centre. All rights
            reserved.
          </p>
          <div className="flex gap-6 mt-4 md:mt-0" data-id="element-132">
            <a href="#" className="hover:text-slate-300 transition-colors focus-visible-ring rounded-sm" data-id="element-133">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-slate-300 transition-colors focus-visible-ring rounded-sm" data-id="element-134">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}